export const sendBackRadioOptions = [
  'didNotAnswer',
  'missingSomeDetail',
  'needMoreClarification',
  'requireAttachment',
  'noLongerValid',
  'doesNotSupport',
  'other',
];
